import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { addNewProduct } from "../../redux/shopping/actions";

const AddProduct = () => {
  const dispatch = useDispatch();
  const [state, setState] = useState({
    name: "",
    category: "",
    image: "",
    price: "",
    quantity: "",
  });
  const onSubmit = (e) => {
    e.preventDefault();
    dispatch(addNewProduct(state));
    
    setState({
      name: "",
      category: "",
      image: "",
      price: "",
      quantity: "",
    });
  };

  return (
    <div className="formContainer">
      <h4 className="formTitle">Add New Product</h4>
      <form
        className="space-y-4 text-[#534F4F]"
        id="lws-addProductForm"
        onSubmit={onSubmit}
      >
        {/* product name */}
        <div className="space-y-2">
          <label htmlFor="lws-inputName">Product Name</label>
          <input
            className="addProductInput"
            id="lws-inputName"
            type="text"
            required
            name="name"
            onChange={(e) => {
              setState({ ...state, name: e.target.value });
            }}
          />
        </div>
        {/* product category */}
        <div className="space-y-2">
          <label htmlFor="lws-inputCategory">Category</label>
          <input
            className="addProductInput"
            id="lws-inputCategory"
            type="text"
            required
            name="category"
            onChange={(e) => {
              setState({ ...state, category: e.target.value });
            }}
          />
        </div>
        {/* product image url */}
        <div className="space-y-2">
          <label htmlFor="lws-inputImage">Image Url</label>
          <input
            className="addProductInput"
            id="lws-inputImage"
            type="text"
            required
            name="image"
            onChange={(e) => {
              setState({ ...state, image: e.target.value });
            }}
          />
        </div>
        {/* price & quantity container */}
        <div className="grid grid-cols-2 gap-8 pb-4">
          {/* price */}
          <div className="space-y-2">
            <label htmlFor="ws-inputPrice">Price</label>
            <input
              className="addProductInput"
              type="number"
              id="lws-inputPrice"
              required
              name="price"
              onChange={(e) => {
                setState({ ...state, price: parseInt(e.target.value) });
              }}
            />
          </div>
          {/* quantity */}
          <div className="space-y-2">
            <label htmlFor="lws-inputQuantity">Quantity</label>
            <input
              className="addProductInput"
              type="number"
              id="lws-inputQuantity"
              required
              name="quantity"
              onChange={(e) => {
                setState({ ...state, quantity: parseInt(e.target.value) });
              }}
            />
          </div>
        </div>
        {/* submit button */}
        <button type="submit" id="lws-inputSubmit" className="submit">
          Add Product
        </button>
      </form>
    </div>
  );
};

export default AddProduct;
